export const environment = {
  base_url: 'https://mindbasedevsuperapi.appgrowthcompany.com/',
  image_url: 'https://mindbasedevsuperapi.appgrowthcompany.com/admin/media/uploadFile',
  rememberMeKey: 'MB_RM_SK_D',
  googleKey: 'AIzaSyDIZwbQqi5J9a7DAHuTGs8_zbKK6by891s',
  stripePublicKey: 'pk_test_51Qpp54E9dCHbiXJV6Okor1RpLgwCLKDTvIIOq7SFdVfU7Q1UyuoVFactBrmrdqCe1ZYcx4gh53KIZjJDh4522teq00jWleYgRa',
  storageKey: 'MB_A_SK_D',
  firebaseConfig: {
    apiKey: 'AIzaSyA74yJXmt34C2E_yyTQOgwMlH12O90rS9w',
    authDomain: 'prepbase-76b91.firebaseapp.com',
    projectId: 'prepbase-76b91',
    storageBucket: 'prepbase-76b91.firebasestorage.app',
    messagingSenderId: '181364161362',
    appId: '1:181364161362:web:ece346c7c563a02681d88b',
    measurementId: 'G-B2PL554LD4',
    vapidKey: 'BAeAjs2pkYIY9TwQfEw6394Sf1-drYjtBpqmXfxj38au1sEkS-TWxUQ35lgn2AI5XlMBshcUjY6snJIAyR1mnCw'
  },
  socket_url: 'https://stagesocket.prep-base.com'
};
